import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IconSanitizerService, TooltipDirective } from 'ngx-lib';

@Component({
    selector: 'app-descriptive-item',
    templateUrl: './descriptive-item.component.html',
    styleUrls: ['./descriptive-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TooltipDirective]
})
export class DescriptiveItemComponent {
    @Input()
    text: string;

    @Input()
    tooltip?: string;

    pendingUpdateIcon: SafeHtml;

    constructor(private readonly iconSanitizer: IconSanitizerService) {
        this.pendingUpdateIcon = this.iconSanitizer.getIcon('pendingUpdate');
        this.text = '';
    }
}
